import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getDefaultDateTimeFormat } from './dateTimePicker.utils';
dayjs.extend(utc);
export var DateTimePickerInputStringsForDocs = function () {
    return {
        /** The ARIA label of the input’s clear button. */
        'dateTimePickerInput.clearButton.ariaLabel': 'Clear',
        /** A function that formats the selected date-time. */
        'dateTimePickerInput.dateTimeFormat': function (_a) {
            var dateTimeISO = _a.dateTimeISO, use12HourClock = _a.use12HourClock, withSeconds = _a.withSeconds;
            return dateTimeISO
                ? dayjs.utc(dateTimeISO).local().format(getDefaultDateTimeFormat({ use12HourClock: use12HourClock, withSeconds: withSeconds }))
                : '';
        },
    };
};
export var DateTimePickerInputStrings = DateTimePickerInputStringsForDocs();
